import type { ReactDatePickerCustomHeaderProps } from 'react-datepicker';

import ChevronIcon from '~shared/assets/icons/chevron.svg?react';

import { IconButton } from '@breezeventures/ui-kit/icon-button';
import { Typography } from '@breezeventures/ui-kit/typography';
import { format } from 'date-fns';
import { enUS } from 'date-fns/locale';

type Props = ReactDatePickerCustomHeaderProps & {
  withNavigation?: boolean;
};

export const CustomHeader = ({
  monthDate,
  withNavigation = false,
  decreaseMonth,
  increaseMonth,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
}: Props) => {
  return (
    <div className="flex items-center gap-2 px-2 py-3">
      {withNavigation && (
        <IconButton
          type="button"
          variant="ghost"
          size="s"
          aria-label="Previous month"
          disabled={prevMonthButtonDisabled}
          onClick={decreaseMonth}
        >
          <ChevronIcon className="rotate-90" />
        </IconButton>
      )}

      <Typography.Text
        tag="span"
        size="m"
        weight="medium"
        className="grow text-center"
      >
        {format(monthDate, 'LLLL', { locale: enUS })}
      </Typography.Text>

      {withNavigation && (
        <IconButton
          type="button"
          variant="ghost"
          size="s"
          aria-label="Next month"
          disabled={nextMonthButtonDisabled}
          onClick={increaseMonth}
        >
          <ChevronIcon className="-rotate-90" />
        </IconButton>
      )}
    </div>
  );
};
